export default {
  brands: [],
  brand: undefined,
};
